import { useEffect, useState } from 'react';

/**
 * Hook that animates dots in a loading text (e.g., "Adding." → "Adding.." → "Adding...")
 * Dots maintain their space even when invisible to keep button width consistent.
 * @param isLoading - Whether the loading state is active
 * @param intervalMs - Interval between dot changes (default: 500ms)
 * @returns The number of visible dots (1, 2, or 3)
 */
export function useAnimatedDots(isLoading: boolean, intervalMs: number = 500): number {
  const [visibleDotCount, setVisibleDotCount] = useState(1);

  useEffect(() => {
    if (!isLoading) {
      setVisibleDotCount(1);
      return;
    }

    const interval = setInterval(() => {
      setVisibleDotCount((prev) => (prev >= 3 ? 1 : prev + 1));
    }, intervalMs);

    return () => clearInterval(interval);
  }, [isLoading, intervalMs]);

  return visibleDotCount;
}
